(() => {
    const CampaignLevels = window.Dashboard.Models.Lookups.CampaignLevels;

    class CampaignCommunicationTextReplacementService {
        constructor(
            $scope,
            brandId,
            storesService,
            errorService,
            dashboardConfig
        ) {
            this.$scope = $scope;
            this.brandId = brandId;
            this.StoresService = storesService;
            this.ErrorService = errorService;
            this.DashboardConfig = dashboardConfig;
        }

        initialiseForCampaign(campaignTemplate) {
            this.longestVoucherCode = "";
            this.longestVoucherExpiryDays = 0;
            this.longestStoreName = "";
            this.longestStoreAddress = "";
            this.longestStoreTelephoneNumber = "";
            this.longestShortURL = this.DashboardConfig.LongestShortUrl;

            this.campaignTemplate = campaignTemplate;
            this._populateLongestVoucherCode();
            this._populateLongestVoucherExpiryDays();

            if (this.shouldLoadAllBrandStores()) {
                this._loadStores();
            } else {
                this.stores = this.campaignTemplate.StoreAssociations;
                this._populateLongestStoreName();
                this._populateLongestStoreAddress();
                this._populateLongestStoreTelephoneNumber();
            }

            return this;
        }

        shouldLoadAllBrandStores() {
            if (!this.campaignTemplate) {
                throw new Error("no campaign template set");
            }
            if (!Array.isArray(this.campaignTemplate.StoreAssociations)) {
                return true;
            }
            if (this.campaignTemplate.StoreAssociations.length === 0) {
                return true;
            }
            if (this.campaignTemplate.StoreAssociations.length > 1) {
                return false;
            }
            // if there is a single association with a zero id, that's
            // the marker for "all stores"
            const association = this.campaignTemplate.StoreAssociations[0];
            return association.Id === 0;
        }

        /**
         * Replaces the message variable placeholders with the content
         */
        replaceVariables(
            messageType,
            brandName,
            inboxMessageValue,
            communication
        ) {
            let message = "";
            switch (messageType) {
                case Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.sms:
                    if (communication.SMS) {
                        message = communication.SMS.Text;
                    }
                    break;
                case Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.push:
                    if (communication.PushNotification && communication.PushNotification.Text) {
                        message = communication.PushNotification.Text;
                    }
                    break;
                case Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes.inbox:
                    message = inboxMessageValue;
                    break;
            }
            if (!message) {
                message = "";
            }
            message = message.replace(new RegExp(communication.storeNameRegex(messageType)), this.longestStoreName);
            message = message.replace(new RegExp(communication.voucherCodeRegex(messageType)), this.longestVoucherCode);
            message = message.replace(new RegExp(communication.brandNameRegex(messageType)), brandName);
            const startDateString = dateString(this.campaignTemplate.StartDate);
            const startDate = moment(startDateString);
            const endDate = moment(dateString(this.campaignTemplate.EndDate));
            const formattedStartDate = startDate.format(this.campaignTemplate.DateFormat);
            const formattedStartTime = startDate.format(this.campaignTemplate.TimeFormat);
            const formattedEndDate = endDate.format(this.campaignTemplate.DateFormat);
            const formattedEndTime = endDate.format(this.campaignTemplate.TimeFormat);
            message = message.replace(new RegExp(communication.startDateRegex(messageType)), formattedStartDate);
            message = message.replace(new RegExp(communication.startTimeRegex(messageType)), formattedStartTime);
            message = message.replace(new RegExp(communication.endDateRegex(messageType)), formattedEndDate);
            message = message.replace(new RegExp(communication.endTimeRegex(messageType)), formattedEndTime);
            message = message.replace(new RegExp(communication.customerFirstNameRegex(messageType)), "CustomerFirstName");
            message = message.replace(new RegExp(communication.customerLastNameRegex(messageType)), "CustomerLastName");
            message = message.replace(new RegExp(communication.storeContactNumberRegex(messageType)), this.longestStoreTelephoneNumber);
            message = message.replace(new RegExp(communication.storePhysicalAddressRegex(messageType)), this.longestStoreAddress);
            message = message.replace(new RegExp(communication.shortURLRegex(messageType)), this.longestShortURL);
            message = message.replace(new RegExp(communication.voucherExpiryDaysRegex(messageType)), this.longestVoucherExpiryDays);
            return message;
        }

        listAllInvalidVariables(
            inboxMessageValue,
            communication
        ) {
            const communicationTypes = Dashboard.Models.Lookups.CampaignTemplateCommunicationTypes;
            let invalid = [];
            const textVarsRegex = /\{(.+?)\}/g
            const inboxVarsRegex = /(?!@Raw\(Model\.GenerateCallbackFunction)(@Raw\(Model\.(.+?)\))/g
            invalid = invalid.concat(listInvalidVariablesFor(communication, inboxMessageValue, communicationTypes.inbox, inboxVarsRegex));
            invalid = invalid.concat(listInvalidVariablesFor(communication, communication.SMS.Text, communicationTypes.sms, textVarsRegex));
            invalid = invalid.concat(listInvalidVariablesFor(communication, communication.PushNotification.Text, communicationTypes.push, textVarsRegex));
            return invalid;
        }

        _populateLongestVoucherCode() {
            let longestVoucherCode = "";
            for (const voucher of (this.campaignTemplate.Vouchers || [])) {
                if (voucher.VoucherCode && voucher.VoucherCode.length > longestVoucherCode.length) {
                    longestVoucherCode = voucher.VoucherCode;
                }
            }

            this.longestVoucherCode = longestVoucherCode;
        }

        _populateLongestVoucherExpiryDays() {
            let longestVoucherExpiryDays = 0;
            for (const voucher of (this.campaignTemplate.Vouchers || [])) {
                if (voucher.ExpiryDaysOverride > longestVoucherExpiryDays) {
                    longestVoucherExpiryDays = voucher.ExpiryDaysOverride;
                }
            }
            this.longestVoucherExpiryDays = longestVoucherExpiryDays;
        }

        _loadStores() {
            if (this.$scope.$root) {
                this.$scope.$root.isLoading = true;
            }
            this.StoresService.getStoresForBrand(this.brandId, true)
                .then(result => {
                    this.stores = result.data.Stores;
                    this._populateLongestStoreName();
                    this._populateLongestStoreAddress();
                    this._populateLongestStoreTelephoneNumber();
                }).catch(err => {
                this.ErrorService.showError('An error occurred when loading the campaign template', err);
            }).finally(() => {
                if (this.$scope.$root) {
                    this.$scope.$root.isLoading = false;
                }
            });
        }

        _populateLongestStoreName() {
            this.longestStoreName = (this.stores || []).reduce(
                (acc, cur) => {
                if (!cur.Name) {
                    return acc;
                }
                return cur.Name.length > acc.length
                    ? cur.Name
                    : acc;
            }, "");
        }

        _populateLongestStoreAddress() {
            this.longestStoreAddress = (this.stores || []).reduce(
                (acc, cur) => {
                if (!cur.Address) {
                    return acc;
                }
                return cur.Address.length > acc.length ? cur.Address : acc;
            }, "");
        }

        _populateLongestStoreTelephoneNumber() {
            this.longestStoreTelephoneNumber = (this.stores || []).reduce(
                (acc, cur) => {
                if (!cur.TelephoneNumber) {
                    return acc;
                }
                return cur.TelephoneNumber.length > acc.length ? cur.TelephoneNumber : acc;
            }, "");
        }
    }

    function listInvalidVariablesFor(
        communication,
        message,
        type,
        someRegex
    ) {
        const strippedMessage = stripValidRegex(communication, message, type);
        const matched = strippedMessage.match(someRegex) || [];
        return matched.map(item => {
            return {
                propertyName: item,
                propertyType: type
            }
        });
    }

    function replaceValidVars(
        communication,
        message,
        prop,
        messageType
    ) {
        if (!message) {
            return "";
        }
        const getRegexForMessageType = communication[prop];
        if (typeof getRegexForMessageType !== "function") {
            console.error(`no regex for prop: '${prop}'`);
            return message;
        }
        const regex = getRegexForMessageType(messageType);
        return message.replace(regex, "");
    }

    function stripValidRegex(communication, message, messageType) {
        if (!message) {
            return "";
        }
        [
            "storeNameRegex",
            "voucherCodeRegex",
            "brandNameRegex",
            "startDateRegex",
            "startTimeRegex",
            "endDateRegex",
            "endTimeRegex",
            "customerFirstNameRegex",
            "customerLastNameRegex",
            "storeContactNumberRegex",
            "storePhysicalAddressRegex",
            "shortURLRegex",
            "voucherExpiryDaysRegex"
        ].forEach((prop) => {
            message = replaceValidVars(
                communication,
                message,
                prop,
                messageType
            );
        })
        return message;
    }

    function dateString(value) {
        if (typeof value === "string") {
            const
                timestamp = Date.parse(value),
                asDate = new Date(timestamp);
            return asDate.toISOString();
        }
        if (value instanceof Date) {
            return value.toISOString();
        }
        if (!value) {
            return value;
        }
        throw new Error(`can't perform dateString on value:\n${value}\nwith type: ${typeof value}`);
    }

    window.CampaignCommunicationTextReplacementService = CampaignCommunicationTextReplacementService;

})();
